export default __webpack_public_path__ + "static/media/Méthode naturelle.941485c3.jpg";